import { Routes } from '@angular/router';
import { ModulesListComponent } from './pages/modules-list/modules-list';
import { InvertersListComponent } from './pages/inverters-list/inverters-list';
import { StoragesListComponent } from './pages/storages-list/storages-list';
import { TemplatesListComponent } from './pages/templates-list/templates-list';

/**
 * Catalog Routes
 * Nested under /organizations/:slug/catalog
 *
 * Structure:
 * - /catalog/equipment/modules
 * - /catalog/equipment/inverters
 * - /catalog/equipment/storages
 * - /catalog/templates
 */
export const catalogRoutes: Routes = [
  {
    path: '',
    redirectTo: 'templates',
    pathMatch: 'full',
  },
  {
    path: 'templates',
    component: TemplatesListComponent,
    data: { title: 'Vorlagen' },
  },
  {
    path: 'equipment',
    children: [
      {
        path: '',
        redirectTo: 'modules',
        pathMatch: 'full',
      },
      {
        path: 'modules',
        component: ModulesListComponent,
        data: { title: 'Module' },
      },
      {
        path: 'inverters',
        component: InvertersListComponent,
        data: { title: 'Wechselrichter' },
      },
      {
        path: 'storages',
        component: StoragesListComponent,
        data: { title: 'Speicher' },
      },
    ],
  },
];
